import { createContext } from "react";

const MainContext = createContext({
  isAuthed: false,
  boxesList: [],
  userTypes: [],
  cards: { one: [], two: [], three: [], four: [], five: [], six: [], seven: [], eight: [], nine: [] },
  handleEditBoxlist: () => {},
  handleUserType: () => {},
  handleIsAuthed: () => {},
  handleCards: () => {},
});

export default MainContext;
